
import { mapActions, mapGetters } from 'vuex'
import ProductTitle from './product-title.vue'
import PriceInfo from './price-info.vue'
import StampedReviews from './stamped-reviews.vue'
import ColorSwatches from './color-swatches.vue'
import SizeGuide from './size-guide.vue'
import SizeSelect from './size-select.vue'
import FittingGuide from './fitting-guide.vue'
import CtaMain from './cta-main.vue'
import ReturnsShipping from './returns-shipping.vue'
import QuickaddModal from './quickadd-modal.vue'
import LolePicture from '@/components/picture/lole-picture'
import ProductFlap from '@/components/product-card/ProductFlap.vue'
import Price from '@/components/price/price.vue'

export default {
  components: {
    ProductTitle,
    PriceInfo,
    StampedReviews,
    ColorSwatches,
    SizeGuide,
    SizeSelect,
    FittingGuide,
    CtaMain,
    ReturnsShipping,
    QuickaddModal,
    LolePicture,
    ProductFlap,
    Price,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    wording: {
      type: Object,
      required: true,
    },
    reviewsBreakdown: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedSize: null,
      noSelectedSize: false,
      selectedColor: null,
      variantId: null,
      stickyBottomBar: false,
      openSizeSelectModal: false,
      stickySizeToggled: false,
      intentAddToCart: false,
    }
  },
  computed: {
    ...mapGetters({
      vxScroll: 'getScroll',
      vxGetSelectedProductId: 'pdp/getSelectedProductId',
      vxGetSelectedSize: 'pdp/getSelectedSize',
    }),
    stickyOffsetHeight() {
      // const ebr = this.$refs.buyboxstickyBottomBar.getBoundingClientRect()
      // return Math.ceil(ebr.height + 20)
      return 120
    },
    productThumbnail() {
      return this.product.medias[0] ? this.product.medias[0].src : null
    },
    isFinalSale() {
      return this.product?.isFinalSale
    },
  },
  watch: {
    'vxScroll.current'() {
      const mainCtaOffsetTop =
        this.$refs.buyboxCtaMain.$el.getBoundingClientRect()
      if (mainCtaOffsetTop.top < 0) {
        this.stickyBottomBar = true
        document
          .querySelector('.lole-site-container')
          .setAttribute('style', `padding-bottom: ${this.stickyOffsetHeight}px`)
      } else {
        this.stickyBottomBar = false
        document.querySelector('.lole-site-container').removeAttribute('style')
      }
    },
    selectedSize() {
      if (this.stickySizeToggled && this.selectedSize.name) {
        this.toggleStickyBottomSizeSelect()
      }
    },
    vxGetSelectedSize() {
      if (this.vxGetSelectedSize === null) this.selectedSize = null
    },
    product() {
      this.selectedSize = null
      this.noSelectedSize = false
      this.selectedColor = null
      this.variantId = null
      this.stickyBottomBar = false
      this.openSizeSelectModal = false
      this.stickySizeToggled = false
      this.intentAddToCart = false
    },
  },
  mounted() {
    this.preselectProductSize()
  },
  methods: {
    ...mapActions({
      vxAddProductsToCart: 'product/addProductsToCart',
      vxPDPSelectProduct: 'pdp/selectProduct',
      vxPDPResetProduct: 'pdp/resetProduct',
      vxPDPSelectSize: 'pdp/selectSize',
    }),
    selectSize(size) {
      if (!size.availability) return
      this.noSelectedSize = false
      this.selectedSize = size
      this.setCurrentVariantId()

      // Handle Intent Add To Cart
      if (this.intentAddToCart) this.addToCart()

      // Add to PDP store
      const selectedProduct = this.product
      selectedProduct.selectedSize = this.selectedSize
      this.vxPDPSelectProduct(selectedProduct)
      this.vxPDPSelectSize(this.selectedSize)
    },
    setCurrentVariantId() {
      this.variantId = this.selectedSize ? this.selectedSize.id : null
    },
    addToCart() {
      if (this.isOnlySizeProduct()) this.selectedSize = this.product.sizes[0]
      if (!this.selectedSize) {
        if (this.stickyBottomBar && !this.stickySizeToggled) {
          this.toggleStickyBottomSizeSelect()
        }
        this.noSelectedSize = true
        this.intentAddToCart = true
        return
      }
      this.vxAddProductsToCart({
        location: 'product-page',
        products: [
          {
            product: this.product,
            variant: {
              size_name: this.selectedSize.name,
              id: this.selectedSize.id,
              barcode: this.selectedSize.barcode,
              sku: this.selectedSize.sku,
              quantity: 1,
            },
          },
        ],
      })
      if (this.intentAddToCart) this.intentAddToCart = false
      this.$googleAnalyticsEvents.GA4AddToCart(this.product)
    },
    isOnlySizeProduct() {
      return this.product.sizes.length < 2
    },

    handleFocusOut() {
      this.stickySizeToggled = false
    },
    toggleStickyBottomSizeSelect() {
      if (!this.stickySizeToggled) {
        this.stickySizeToggled = true
        // this.$refs.stickySizeSelect.focus()
      } else {
        this.stickySizeToggled = false
      }
    },
    preselectProductSize() {
      try {
        if (this.vxGetSelectedProductId) {
          if (this.vxGetSelectedProductId === this.product.internal_type) {
            if (this.vxGetSelectedSize) {
              const preselectSize = this.product.sizes.filter((size) => {
                return (
                  size.name === this.vxGetSelectedSize.name && size.availability
                )
              })

              if (preselectSize.length) {
                this.selectSize(preselectSize[0])
              }
            } else {
              throw new Error(
                'failed to get previous selected size for this product'
              )
            }
          } else {
            this.vxPDPResetProduct()
          }
        }
      } catch (err) {
        this.$sentryException(err, {
          source: 'PDP Buybox',
          level: 'error',
          extra: `Error in preselectProductSize: ${err.message}`,
        })
      }
    },
  },
}
